import { type AxiosRequestConfig } from 'axios';

import { fetchApi } from '../../services';
import { getSaviApiUrlLists } from '../../services/ispmUtil';
import { type DashboardListApiResponse } from '../types';

const { DASHBOARD_LIST_URL } = getSaviApiUrlLists(false);

function isDashboardListResponse(
  data: unknown
): data is DashboardListApiResponse {
  return typeof data === 'object' && data !== null;
}

// Function to fetch ISPM suggestions
const getDashboardList = async (
  url?: string
): Promise<DashboardListApiResponse> => {
  const dashboardListUrl = url ?? DASHBOARD_LIST_URL;
  const config: AxiosRequestConfig = {
    timeout: 30000, // Set timeout to 30 seconds
  };

  const response = await fetchApi(
    dashboardListUrl,
    config,
    isDashboardListResponse
  );

  return response;
};

export default getDashboardList;
